import { useGLTF } from "@react-three/drei"
import { Suspense, useEffect, useRef } from "react";


const LoadModel = ({
    name,
    url,
    visible,
    rotation = [0, 0, 0],
    translation = [0, 0, 0]
}) => {
    const model = useGLTF(url);
    const groupRef = useRef();

    useEffect(() => {
        if (groupRef.current) {
            groupRef.current.position.x += translation[0];
            groupRef.current.position.y += translation[1];
            groupRef.current.position.z += translation[2];
            console.log(translation)
        }
    }, [model, translation]);

    return (
        <Suspense fallback={null} key={name}>
            {visible &&
                <group ref={groupRef} rotation={rotation}>
                    <primitive object={model.scene} />
                </group>
            }
        </Suspense>
    );
}

export default LoadModel